import { createContext } from 'react';

export const LogContext = createContext({
  logs: [],
  log: {},
});
